// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Quo6","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2EVWl","obliqueLine":"membershipbadge_obliqueLine__1459e"};